import global from "Main/stores/modules/global";
import { createStore } from "vuex";
import comments from "./modules/comments";
import createComment from "./modules/createComment";
import creator from "./modules/creator";
import donations from "./modules/donations";
import modal from "./modules/modal";
import orders from "./modules/orders";
import sections from "./modules/sections";
import singleCommentModal from "./modules/singleCommentModal";
import threadedComments from "./modules/threadedComments";

export default createStore({
  modules: {
    comments,
    createComment,
    creator,
    donations,
    global,
    modal,
    orders,
    sections,
    singleCommentModal,
    threadedComments,
  },
});
